import { Toro } from '../../common/enumerations';
import { DeviceFwUpdateInfoListItem } from './device-fw-update-info-list-item.model';

export abstract class DeviceFwUpdateInfo
{
    protected constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);

            if (json.DisplayListItem) this.DisplayListItem = new DeviceFwUpdateInfoListItem(json.DisplayListItem);
        }
    }

    DeviceId: number;
    DeviceTypeId: Toro.DeviceType;
    Name: string;
    Description: string;
    HasPendingUpdate = false;
    CurrentFwVer: number;
    AvailableFwVer: number;
    AvailFwDescription: string;
    DisplayListItem: DeviceFwUpdateInfoListItem;
}
